import ProductLogo from './ProductLogo';
import CustomerLogo from './CustomerLogo';

export {
  ProductLogo,
  CustomerLogo
};


// WEBPACK FOOTER //
// ./src/components/logo/index.js